module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/rolling-pin-df74f288591d1c751f58a9eb1faa65d1.svg";